import JiraIcon from '../../../../NRIcons/IntegrationIcons/JiraIcon';
import { SETTINGS_INTEGRATIONS_PATH } from '../integrations.constants';

export const JIRA_INTEGRATION_ID = 'JIRA';

export const JIRA_INTEGRATION_TYPE = 'TICKETING';

/** OAuth redirect path registered with Atlassian; BE exchanges code at /jira/oauth/callback then redirects here. */
export const JIRA_INTEGRATION_SETUP_PATH = `${SETTINGS_INTEGRATIONS_PATH}/jira/setup`;

export const JIRA_INTEGRATION_CONFIGURATION_PATH = `${SETTINGS_INTEGRATIONS_PATH}/jira/configuration`;

// TODO: Confirm configuration guide URL once BE/product docs are finalized.
export const JIRA_CONFIGURATION_GUIDE_URL = 'https://kb.netrise.io/jira-integration-guide';

// TODO: implement status values with the BE integration status enum once the API contract is defined.
export const JIRA_INTEGRATION_STATUS = {
  NOT_CONNECTED: 'NOT_CONNECTED',
  CONNECTED: 'CONNECTED',
  PENDING: 'PENDING',
  INSTALL_FAILED: 'INSTALL_FAILED',
  AUTH_EXPIRED: 'AUTH_EXPIRED'
};

export const JIRA_INTEGRATION_SECTION_LABELS = {
  EARLY_ADOPTER_BADGE: 'Early Adopter',
  EARLY_ADOPTER_TOOLTIP: "We're in Early Access. Please report any issues and share feedback with Customer Support.",
  CONFIGURATION_GUIDE: 'Go to configuration guide',
  CONNECT: 'Connect',
  CONFIGURE: 'Configure',
  RETRY: 'Retry',
  RECONNECT: 'Reconnect',
  SPACES: 'Spaces',
  LAST_UPDATED: 'Last updated'
};

export const JIRA_INTEGRATION_STATUS_LABELS = {
  [JIRA_INTEGRATION_STATUS.CONNECTED]: 'Connected',
  [JIRA_INTEGRATION_STATUS.PENDING]: 'Pending',
  [JIRA_INTEGRATION_STATUS.NOT_CONNECTED]: 'Disconnected',
  [JIRA_INTEGRATION_STATUS.INSTALL_FAILED]: 'Install failed',
  [JIRA_INTEGRATION_STATUS.AUTH_EXPIRED]: 'Auth expired'
};

export const JIRA_AVAILABLE_INTEGRATION = {
  Icon: JiraIcon,
  serviceName: 'Atlassian Jira',
  description: 'Open and update tickets on issues within reports',
  integrationId: JIRA_INTEGRATION_ID
};

/** Sentinel for no assignee in the UI select — omit assignee from CreateJiraIssue fields. */
export const JIRA_UNASSIGNED_ASSIGNEE_ID = '__unassigned__';

export const JIRA_ASSIGNEE_UNASSIGNED_LABEL = 'Unassigned';

export const JIRA_TEAM_SELECT_LABELS = {
  SELECT: 'Select',
  SEARCH: 'Search for a team...'
};

export function isJiraUnassignedAssignee(assigneeId) {
  return !assigneeId || assigneeId === JIRA_UNASSIGNED_ASSIGNEE_ID;
}

export const AVAILABLE_INTEGRATIONS_CONFIG = {
  type: JIRA_INTEGRATION_TYPE,
  items: [JIRA_AVAILABLE_INTEGRATION]
};
